import { ActivitySummaryTableState } from '../../typings'
import type { SetActivitySummaryTableStateAction } from './typings'

export const setActivitySummaryTableStateActionCreator = (
  payload: Partial<ActivitySummaryTableState>,
): SetActivitySummaryTableStateAction => ({
  type: 'activitySummary/setTableState',
  payload,
})
